<template>
  <div id="app">
    <Header/>
    <Body/>
    <Footer/>
  </div>
</template>

<script>
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueParallaxJs from 'vue-parallax-js'
import Header from './components/Header'
import Body from './components/Body'
import Footer from './components/Footer'
import 'bootstrap/dist/css/bootstrap.css'
import VueLazyload from 'vue-lazyload'
var SocialSharing = require('vue-social-sharing')
var VueScrollTo = require('vue-scrollto')
// import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
Vue.use(VueParallaxJs, {
    className: 'parallax-element'
})
Vue.use(VueScrollTo, {
     duration: 1000,
     easing: "ease",
     offset: -75
})
Vue.use(SocialSharing)
Vue.use(VueLazyload, {
  preLoad: 1.9,
  error: '/2017-annual-report/static/images/placeholder_thumbnail.jpg',
  attempt: 3,
  // listenEvents: [ 'scroll' ],
  // observer: true, //Intersection_Observer
  // observerOptions: {
  //   rootMargin: '0px',
  //   threshold: 0.1
  // }
})

export default {
  name: 'app',
  components: {
    Header, Body, Footer
  },
  data () {
    return {
      scrolled: false
    }
  }
}
</script>

<style lang="scss">
// global styles
@import "./global.scss";
#app {
  font-family: 'Open Sans', arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $dark_gray;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  overflow-x: hidden;
  // font-size: 18px;
  // line-height: 30px;
  font-size: 16px;
  line-height: 24px;
  @media all and (min-width: $md){
    font-size: 18px;
    line-height: 30px;
  }
  h1, h2 {
    font-family: "tablet-gothic-condensed", arial, sans-serif;
    // text-align: center;
    width: 100%;
    font-style: italic;
    font-weight: 800;
  }
  h1 {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 35px;
    line-height: 45px;
    @media all and (min-width: $md){
      font-size: 65px;
      line-height: 75px;
    }
    @media all and (min-width: $lg){
      font-size: 85px;
      line-height: 95px;
    }
  }
  h2 {
    font-size: 20px;
    font-weight: bold;
    font-style: italic;
    text-transform: uppercase;
    line-height: 26px;
    @media all and (min-width: $md){
      font-size: 35px;
      line-height: 42px;
    }
  }
  p {
    margin: 1rem 0;
    text-align: left;
  }
  ul {
    padding: 0;
  }
  li {
    margin: 24px 0px 24px 30px;
    padding: 0 10px;
    list-style-image: url('./assets/list-item.svg');
  }
  a {
    color: $blue;
  }
  img {
    max-width: 100%;
  }

  .modal-footer {
    display: none;
  }
  // bootstrap overrides {
  .carousel {
    width: 100%;
    &.mobile {
      padding-bottom: 32px;
    }
  }
  .carousel-indicators {
    margin: 0;
    bottom: 0px;
    background: rgba(0,0,0,0.5);
    @media all and (min-width: $md){
      margin: 0 15%;
      background: none;
    }
    li {
      width: 12px;
      height: 12px;
      padding: 0;
      margin: 10px;
      border-radius: 50%;
      cursor: pointer;
      list-style: none;
      @media all and (min-width: $md){
        width: 15px;
        height: 15px;
      }
    }
  }
  .carousel-caption {
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    padding-bottom: 10px;
    width: 100%;
    padding-top: 25px;
    display: none;
    @media all and (min-width: $md){
      display: block;
    }
    p {
      text-align: center;
      font-size: 14px;
      margin: 0;
      @media all and (min-width: $md){
        font-size: 16px;
        margin: 1rem 0 1.5rem;
        display: block;
      }
    }
  }
  // maybe remove this
  .col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col, .col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm, .col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md, .col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg, .col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl, .col-xl-auto {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue